import { useQuery } from '@tanstack/react-query';
import { fridgeService, type FridgeOptions } from 'app/javascript/services/fridge';

// Short staleTime: stock moves as sales are made in the app, so the public
// storefront must not show minutes-old availability. retry: false because a
// 404 ("unknown academy") is a normal answer, not a transient failure.
// Keep the legacy flag in the key while older deployed backends can still
// return a different poster catalog from the live storefront.
export function useFridge(slug: string, options: FridgeOptions = {}) {
  const includeOutOfStock = !!options.includeOutOfStock;

  return useQuery({
    queryKey: ['fridge', slug, includeOutOfStock],
    queryFn: () => fridgeService.get(slug, { includeOutOfStock }),
    enabled: !!slug,
    staleTime: 30 * 1000,
    retry: false,
  });
}
